import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $deleteTableRowAtSelection } from "@lexical/table";
import DeleteIcon from "@mui/icons-material/Delete";
import { useCallback, type FC } from "react";
import { ToolbarIconButton } from "../../toolbar/toolbar-icon-button";

export const DeleteRowButton: FC<{ onClick: () => void }> = ({ onClick }) => {
  const [editor] = useLexicalComposerContext();

  const handleDeleteRow = useCallback(() => {
    editor.update(() => {
      $deleteTableRowAtSelection();
      onClick();
      return;
    });
  }, [editor, onClick]);

  return (
    <ToolbarIconButton
      data-analytics-id="lexical-table-menu-delete-row"
      disabled={!editor._editable}
      label={"Delete row"}
      icon={<DeleteIcon data-testid="DeleteIcon" fontSize="small" />}
      data-testid="table-menu-delete-row"
      aria-label="delete-row"
      onClick={handleDeleteRow}
    />
  );
};
